import React from 'react';
import DropdownButton from 'emerald-ui/lib/DropdownButton';
import DropdownItem from 'emerald-ui/lib/DropdownItem';
import populateDocs from './utils/populateDocs';

let zIndex = 1000;

function getZIndex() {
  zIndex -= 1;
  return zIndex;
}

export default {
  ...populateDocs([{ component: DropdownButton, componentName: 'DropdownButton' }], 'DropdownButton'),
  description: (
    <span>
      A Button that toggles a menu of options. It renders a <span className="code">Dropdown</span> component with a{' '}
      <span className="code">Button</span> and a <span className="code">Dropdown.Menu</span> inside. All the props that
      the <span className="code">Dropdown</span> component supports may be passed to{' '}
      <span className="code">DropdownButton</span> since these will be passed down to{' '}
      <span className="code">Dropdown</span>.
    </span>
  ),
  codeSamples: [
    {
      title: 'Default',
      scope: { DropdownButton, DropdownItem },
      whiteBackground: true,
      style: { zIndex: getZIndex() },
      code: `<DropdownButton title="Default">
  <DropdownItem eventKey="1">Action</DropdownItem>
  <DropdownItem eventKey="2">Another action</DropdownItem>
  <DropdownItem eventKey="3" active>
    Active Item
  </DropdownItem>
  <DropdownItem separator />
  <DropdownItem eventKey="4">Separated link</DropdownItem>
</DropdownButton>`,
    },
  ],
};
